export default __webpack_public_path__ + "static/media/training2Md.07621f2a.png";